import { FunctionComponent, useEffect, useState } from "react";
import { DialogContent, Grid, TextField, FormHelperText, MenuItem, Chip, IconButton, DialogActions, Button, CircularProgress, Checkbox } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import file from "client-sdk/src/parcels/file";
import { Controller, useForm } from "react-hook-form";
import { RonadDropzone } from "../../../components/RonadDropzone";
import RonadIcons from "../../../components/iconComponent";
import { getCategories, getSubjects } from "../../../api/ticket/get";
import handleNotfication from "../../../utils/handleNotification";
import handleError from "../../../utils/handleError";
import { createTicket } from "../../../api/ticket/create";
import PartnerRepository from 'client-sdk/src/Repository/partners-repository'
import { uploadTicketFile } from "../../../api/ticket/put";

const ticketPriority = [
  {
    id: 0,
    name: 'LOW',
    title: 'کم',
    color: '#007644',
    bcolor: '#e8faea',
  },
  {
    id: 1,
    name: 'NORMAL',
    title: 'متوسط',
    color: '#FF7E07',
    bcolor: '#ffeedf',
  },
  {
    id: 2,
    name: 'HIGH',
    title: 'زیاد',
    color: '#FF0000',
    bcolor: '#fffafa',
  },
  {
    id: 3,
    name: 'CRITICAL',
    title: 'اضطراری',
    color: 'maroon',
    bcolor: '#fffafa',
  },
];

const ticketType = [
  {
    id: 0,
    name: 'order',
    title: 'سفارش',
    color: '#007644',
    bcolor: '#e8faea',
  },
  {
    id: 1,
    name: 'parcel',
    title: 'محموله',
    color: '#FF7E07',
    bcolor: '#ffeedf',
  }
];

interface CreateTicketModalProps {
  handleCloseModal: () => void
  getTickets: () => void
}
 
const CreateTicket: FunctionComponent<CreateTicketModalProps> = ({handleCloseModal, getTickets}) => {
  const [loading, setLoading] = useState(false)
  const [isHide, setIsHide] = useState(false)
  const [file, setFile] = useState<any>('');
  const [category, setCategory] = useState<string>('')
  const [partner, setPartner] = useState<string>('')
  const [subject, setSubject] = useState<string>('')
  const [partners, setPartners] = useState([])
  const [categories, setCategories] = useState([])
  const [subjects, setSubjects] = useState([])
  const { register, control, errors, handleSubmit, setValue, getValues, watch } =
  useForm({
    defaultValues: {
      linkType: "",
      linkId: '',
      file: null,
      title: null,
      priority: '',
      subject: '',
      msg: '',
      category: ''
    },
  });

  useEffect(() => {
    getCategoryList()
    getPartner()
  }, [])
  const handleRemoveFile = () => {
    setFile(null);
    setValue('file', null);
  };

  const handleFileDropped = (acceptedFile: any) => {
    setFile(acceptedFile);
  };

  const getPartner = async () => {
    try {
      const {response} = await PartnerRepository.getPartners({payload: {page: 0, size: 1000}})
      setPartners(response.data)
    } catch (error) {
      handleError(error)
    }
  }

  const getCategoryList = async () => {
    const response = await getCategories({})
    setCategories(response.data)
  }

  const getSubjectList = async (id:string) => {
    const response = await getSubjects({categoryId: id})
    setSubjects(response.data)
  }

  const onSubmit = async (data: any) => {
    const body = {
      title: data.title,
      priority: 'NORMAL',
      text: data.msg,
      categoryId: category,
      subjectId: subject,
      partnerId: partner,
      linkId: data.linkId,
      linkType: data.linkType,
      isHide
    }
    try {
      setLoading(true);

      const res = await createTicket(body)
      handleNotfication('تیکت با موفقیت ایجاد شدند', 'success');
      file && await uploadFile(file, res.data.content.id, res.data.id)
      getTickets()
      handleCloseModal()
    } catch (err) {
      if (err.response?.status === 400) {
        handleNotfication(err.response?.data?.title, 'error');
      }

      handleError(err);
    } finally {
      setFile(null);
      setLoading(false);
      setValue('file', null);
    }
  };

  const uploadFile = async (ticketFile: any, id: number, ticketId: string) => {
    const form = new FormData()
    form.append('file', ticketFile)
    await uploadTicketFile(form, id, ticketId)
  }

  return ( <form onSubmit={handleSubmit(onSubmit)}>
  <DialogContent style={{ paddingTop: '0' }}>
    <Grid container direction="row" spacing={2}>
      <Grid item xs={12} md={6} lg={6}>
          <Autocomplete
            id="partner"
            options={partners}
            getOptionLabel={option => option.name}
            disableClearable={true}
            onChange={(e: any, newValue: any | null | undefined) => {
              if (newValue) {
                setPartner(newValue.id);
              }
            }}
            renderInput={params => (
              <TextField
                name="partner"
                inputRef={register({ required: false })}
                {...params}
                label="کاربر"
                fullWidth
                variant="outlined"
              />
            )}
          />
          <FormHelperText error focused>
            {errors.category && 'کاربر الزامی میباشد'}
          </FormHelperText>
      </Grid>
      <Grid item xs={12} md={6} lg={6}>
        <div style={{ marginTop: '2px' }}>
          <Controller
            style={{ width: '100%' }}
            control={control}
            name="title"
            label="عنوان"
            error={errors.title}
            rules={{ required: true, minLength: 4 }}
            as={
              <TextField
                style={{ marginTop: '16px', marginBottom: '16px' }}
                fullWidth
                variant="outlined"
              />
            }
          />
        </div>
        {errors.title?.type == "required" && <FormHelperText error focused>
          عنوان الزامی می‌باشد
        </FormHelperText>}
        {errors.title?.type == "minLength" && <FormHelperText error focused>
          حداقل 4کاراکتر وارد شود
        </FormHelperText>}
      </Grid>
    </Grid>
    <Grid container direction="row" spacing={2}>
      <Grid item md={4} lg={4} xs={6}>
        <Controller
          style={{ width: '100%' }}
          control={control}
          id="linkType"
          name="linkType"
          label="مربوط به"
          error={errors.linkType}
          rules={{ required: false }}
          as={
            <TextField
              style={{ marginTop: '16px', marginBottom: '16px' }}
              fullWidth
              variant="outlined"
              select
            >
              {ticketType.map(item => {
                return (
                  <MenuItem value={item.name}>
                    {item.title}
                  </MenuItem>
                );
              })}
            </TextField>
          }
        />
      </Grid>
      {/* <Grid item md={4} lg={4} xs={6}>
        <Controller
          style={{ width: '100%' }}
          control={control}
          id="priority"
          name="priority"
          label="اولویت"
          error={errors.priority}
          rules={{ required: true }}
          as={
            <TextField
              style={{ marginTop: '16px', marginBottom: '16px' }}
              fullWidth
              variant="outlined"
              select
            >
              {ticketPriority.map(item => {
                return (
                  <MenuItem value={item.name}>
                    <Chip
                      icon={
                        <RonadIcons name='circle' size="16px" style={{color: item.color}}/>
                      }
                      label={item.title}
                      style={{
                        color: item.color,
                        backgroundColor: item.bcolor,
                        fontSize: '16px',
                      }}
                    />
                  </MenuItem>
                );
              })}
            </TextField>
          }
        />
        <FormHelperText error focused>
          {errors.priority && 'اولویت الزامی می‌باشد'}
        </FormHelperText>
      </Grid> */}
      <Grid item md={4} lg={4} xs={12}>
        <Controller
          style={{ width: '100%' }}
          control={control}
          name="linkId"
          label="شماره سفارش یا محموله"
          error={errors['linkId']}
          rules={{ required: !!watch('type'), pattern: /[0-9]/ }} 
          as={
            <TextField
              style={{ marginTop: '16px', marginBottom: '16px' }}
              fullWidth
              variant="outlined"
              disabled={watch('type') == "NONE"}
            ></TextField>
          }
        />
        {errors['linkId']?.type == "required" && <FormHelperText error focused>
          شناسه سفارش یا محموله الزامی می‌باشد
        </FormHelperText>}
        {errors['linkId']?.type == "pattern" && <FormHelperText error focused>
          فقط عدد وارد شود
        </FormHelperText>}
      </Grid>
    </Grid>

    <Grid container direction="row" spacing={2}>
      <Grid item md={6} lg={6} xs={6}>
        <Autocomplete
          id="category"
          options={categories}
          getOptionLabel={option => option.name}
          disableClearable={true}
          onChange={(e: any, newValue: any | null | undefined) => {
            if (newValue) {
              setCategory(newValue.id);
              setValue('subject', undefined)
              setSubject(undefined)
              getSubjectList(newValue.id)
            }
          }}
          renderInput={params => (
            <TextField
              name="category"
              inputRef={register({ required: true })}
              {...params}
              label="دسته‌بندی"
              fullWidth
              variant="outlined"
            />
          )}
        />
        <FormHelperText error focused>
          {errors.category && 'دسته‌بندی الزامی میباشد'}
        </FormHelperText>
      </Grid>

      <Grid item md={6} lg={6} xs={6}>
        <Autocomplete
          id="subject"
          options={subjects}
          disabled={!category}
          onChange={(event: any, newValue: any | null) => {
            setSubject(newValue.id);
          }}
          getOptionLabel={option => option?.body}
          disableClearable={true}
          renderInput={params => (
            <TextField
              name="subject"
              {...params}
              inputRef={register({ required: true })}
              label="موضوع"
              variant="outlined"
            />
          )}
        />
        <FormHelperText error focused>
          {errors.category && 'موضوع الزامی میباشد'}
        </FormHelperText>
      </Grid>
    </Grid>

    <Controller
      control={control}
      id="msg"
      name="msg"
      rules={{ required: true }}
      error={errors.msg}
      as={
        <TextField
          inputProps={{
            style: {
              minHeight: '120px',
              maxHeight: '240px',
              padding: '0 8px',
            },
          }}
          margin="normal"
          multiline
          label="متن پیام"
          variant="outlined"
          fullWidth
        />
      }
    />

    <FormHelperText error focused>
      {errors.msg && 'متن پیام الزامی است'}
    </FormHelperText>

    <div>
      <span style={{fontWeight: 'bold'}}>پیغام محرمانه:</span>
      <label>
        <Checkbox
          checked={isHide}
          onChange={e => setIsHide(e.target.checked)}
          id="isHide"
          color="secondary"
          inputProps={{
            'aria-label': 'secondary checkbox',
          }}
        />
        <small style={{color: '#ADADAD'}}>پیغام های محرمانه را مشتریان نخواهند دید.</small>
      </label>
    </div>

    {/* <Grid container direction="row" spacing={2}>
      <Grid item md={12} lg={12}>
      </Grid>
    </Grid> */}
        <RonadDropzone
          register={register}
          onDropped={handleFileDropped}
        />
    {file && (
      <Grid
        style={{
          textAlign: 'left',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <IconButton
          aria-label="close"
          style={{ marginLeft: 'auto' }}
          onClick={handleRemoveFile}
        >
          <RonadIcons name="x-close" color="error"  size="20px"/>
        </IconButton>
        <span style={{ marginTop: '14px' }}>
          <span style={{ fontWeight: 'bold' }}> {file.name} </span>
          <span>( {file.size} KB )</span>
        </span>
      </Grid>
    )}
  </DialogContent>
  <DialogActions>
    <Grid
      container
      spacing={1}
      direction="row-reverse"
      style={{ marginBottom: '8px' }}
    >
      <Grid item>
        <Button
          type="submit"
          variant="contained"
          size="large"
          color="primary"
          style={{ marginLeft: '24px' }}
          disabled={loading}
        >

          {loading ? <CircularProgress style={{ height: "30px", width: "30px" }} /> : `ارسال پیام`}
        </Button>
      </Grid>

      {handleCloseModal ? (
        <Grid item>
          <Button
            type="submit"
            variant="contained"
            size="large"
            color="default"
            onClick={handleCloseModal}
          >
            {`بازگشت`}
          </Button>
        </Grid>
      ) : null}
    </Grid>
  </DialogActions>
</form> );
}
 
export default CreateTicket;